module.exports = "https://www.gc-pro.gnp.com.mx/baef201e262a7da7dc1b3ae0e9596f48.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/beneficios-soy-cliente.svg
// module id = 683
// module chunks = 0